














































import Vue, { PropOptions } from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BorderButton from '@/components/border-button.vue'

export interface Client {
  id: number
  categories: number[]
  oneLetter: string
  clientName: string
  clientDescription: string
  clientSite: string
  gallery: Array<{ src: string; caption: string }>
  projects: Array<{ name: string; url: string }>
  designSelectionAward: boolean
}

export default Vue.extend({
  props: {
    client: {} as PropOptions<Client>
  },

  components: {
    'Swiper': swiper,
    'SwiperSlide': swiperSlide,
    BorderButton
  },

  data() {
    return {
      isLoaded: false,
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        autoHeight: true,
        on: {
          afterInit() {
            console.log('Swiper calculated and ready')
          }
        }
      }
    }
  },

  watch: {
    'client'() {
      if (Object.keys(this.client).length > 0) {
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.height = ''
        document.body.style.overflow = ''
      }
    }
  },

  methods: {
    close() {
      this.$emit('close-modal')
    }
  }
})
